<template>
  <nav class="bg-gradient-to-r from-[#007FCC] to-[#A55CF0] px-4 py-3">
    <div class="flex items-center justify-between max-w-screen-xl mx-auto">
      <a href="https://trurating.com/for-shoppers/" class="hover:no-underline">
        <img
          src="~/assets/images/trurating_logo_transparent.svg"
          alt="TruRating Logo"
          class="h-auto select-none w-28"
        />
      </a>
      <AnimatedNavBarMenu />
    </div>
  </nav>
</template>

<script setup lang="ts">
import AnimatedNavBarMenu from '~/components/Header/AnimatedNavBarMenu.vue'
const { t } = useI18n()
</script>
